<script lang="ts">
    import {Beneficiary} from "../../models/Beneficiary";
    import {USState} from "../../models/USState";
    import {Address} from "../../models/Address";
    import {getAllUSStates, Suffixes, getBeneficiaryRelationshipTypes} from "../../services/ApplicationDataService";
    import {validateField, validatePhone, alphaNumericPattern, validateDate} from "../../services/Utilities";
    import {ValueType} from "../../models/ValueType";
    import AddressUI from "../controls/Address.svelte";
    import MaskInput from "svelte-input-mask/MaskInput.svelte";
    export let beneficiary: Beneficiary | undefined;
    export let beneficiaryAddress: Address;
    let suffixes: string[]
    let usStates: USState[];
    let beneficiaryRelationshipTypes: ValueType[];
    suffixes = Suffixes();
    usStates = getAllUSStates();
    beneficiaryRelationshipTypes = getBeneficiaryRelationshipTypes();
    const namePattern = alphaNumericPattern();

    const handleChange = ({ detail }) => {
          if (detail.inputState.maskedValue.indexOf('34') === 0 || detail.inputState.maskedValue.indexOf('37') === 0) {
                  return;
                }
          if (beneficiary) {
        beneficiary.phoneNumber =  detail.inputState.maskedValue;
        }
      };

    const handleDOBChange = ({ detail }) => {
        if (detail.inputState.maskedValue.indexOf('34') === 0 || detail.inputState.maskedValue.indexOf('37') === 0) {
            return;
        }
        if (beneficiary) {
            beneficiary.personDOB =  detail.inputState.maskedValue;
        }
       
    };

    const handleTrustDateChange =({detail}) => {
        if (detail.inputState.maskedValue.indexOf('34') === 0 || detail.inputState.maskedValue.indexOf('37') === 0) {
            return;
        }
        if (beneficiary) {
            beneficiary.trustDate =  detail.inputState.maskedValue;
        }
    }



</script>
<div class="text-section">
    {#if beneficiary}
        {#if beneficiary && beneficiary.beneficiaryType && [1, 2, 3, 4, 5].includes(beneficiary.beneficiaryType)}
            <div class="text-section">
                <div class="text-row">
                    <div class="text-group">
                        <div class="text-label">Beneficiary Type:</div>
                        <div class="bold-text">{beneficiary.beneficiaryTypeDescription}</div>
                    </div>
                </div>
            </div>
            {#if beneficiary.beneficiaryType == 1}
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>First Name:</label>
                        <input bind:value={beneficiary.personFirst} required pattern={namePattern} />
                          {#if !validateField(beneficiary.personFirst, namePattern) }
                                     <span class="invalidlabel">Valid first name is required</span>
                         {/if}
                    </div>
                </div>
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Middle Name:</label>
                        <input bind:value={beneficiary.personMiddle} maxlength="1"/>
                    </div>
                </div>
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Last Name:</label>
                        <input bind:value={beneficiary.personLast} required  pattern={namePattern} />
                          {#if !validateField(beneficiary.personLast, namePattern) }
                                                  <span class="invalidlabel">Valid last name is required</span>
                                                {/if}
                    </div>
                </div>

                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Suffix:</label>
                        <select bind:value={beneficiary.personSuffix} >
                            <option value=''>Select Suffix</option>
                            {#each suffixes as suffix}
                                <option value={suffix}> {suffix}
                                </option>
                            {/each}
                        </select>

                    </div>
                </div>

                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Birth Date:</label>
                        <MaskInput
                                alwaysShowMask
                                mask="00/00/0000"
                                size={10}
                                showMask
                                maskChar="_"
                                required
                                bind:value={beneficiary.personDOB}
                                on:change={handleDOBChange}
                                style="font-weight: normal;
  font-size: 16px;
  min-width: 270px;
  max-width: 560px;
  height: 40px !important;
  color: #4c4c4c;
  border-radius: 2px;
  border: 1px solid #4c12a1;"
                        />
                        {#if !validateDate(beneficiary.personDOB) }
                            <span class="invalidlabel">Valid date is required</span>
                        {/if}
                    </div>
                </div>

              <div class="control-row">
                <div class="control-group-horizontal">
                   <label>Relationship:</label>
                   <select bind:value="{beneficiary.beneficiaryRelationship}">
                   <option value="">Select</option>
                   {#each beneficiaryRelationshipTypes as relationship}
                      <option value={relationship.key}>{relationship.type}</option>
                   {/each}
</select>
                </div>
             </div>
            {:else if beneficiary.beneficiaryType == 2}
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Company Name:</label>
                        <input bind:value={beneficiary.companyName} required  pattern={namePattern} />
                          {#if !validateField(beneficiary.companyName, namePattern) }
                                                  <span class="invalidlabel">Valid company name is required</span>
                                                {/if}
                    </div>
                </div>

            {:else if beneficiary.beneficiaryType == 3}
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Trust Name:</label>
                        <input bind:value={beneficiary.trustName} required  pattern={namePattern} />
                        {#if !validateField(beneficiary.trustName, namePattern) }
                          <span class="invalidlabel">Valid trust name is required</span>
                        {/if}
                    </div>
                </div>
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Tax Id:</label>
                        <input bind:value={beneficiary.govId} required maxlength="9" minlength="9" pattern="\d*" />
                    </div>
                    {#if (!beneficiary.govId || beneficiary.govId.length < 9 || !Number(beneficiary.govId)  ) }
                        <span class="invalidlabel">Valid tax id is required</span>
                        {/if}
                </div>
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Trust Date:</label>
                                            <MaskInput
                                alwaysShowMask
                                mask="00/00/0000"
                                size={10}
                                showMask
                                maskChar="_"
                                required
                                bind:value={beneficiary.trustDate}
                                on:change={handleTrustDateChange}
                                style="font-weight: normal;
  font-size: 16px;
  min-width: 270px;
  max-width: 560px;
  height: 40px !important;
  color: #4c4c4c;
  border-radius: 2px;
  border: 1px solid #4c12a1;"
                        />
                        {#if !validateDate(beneficiary.trustDate) }
                            <span class="invalidlabel">Valid date is required</span>
                        {/if}
                    </div>
                </div>
            {/if}
            {#if beneficiary.beneficiaryType == 1 || beneficiary.beneficiaryType == 2 || beneficiary.beneficiaryType == 3 }
                <div class="control-row">
                    <div class="control-group-horizontal">
                        <label>Phone Number:</label>

                  <MaskInput   alwaysShowMask
                                mask="000-0000000"
                                type="tel"
                                size={13}
                                showMask
                                maskChar="_"
                                bind:value={beneficiary.phoneNumber}
                                on:change={handleChange}
                               style="font-weight: normal;
  font-size: 16px;
  min-width: 270px;
  max-width: 560px;
  height: 40px !important;
  color: #4c4c4c;
  border-radius: 2px;
  border: 1px solid #4c12a1;"
                              />
                   {#if !validatePhone(beneficiary.phoneNumber) }
                   <span class="invalidlabel">Valid phone number is required</span>
                   {/if}
                   </div>

                </div>

                <AddressUI bind:address={beneficiaryAddress} showLengthOfResidence= "false"/>
            {/if}
        {/if}

    {/if}
</div>
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/forms" as forms;
</style>
